module.exports = "https://www.gc-qa.gnp.com.mx/70b64caba6c773582bd102203a2fee76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/log-out.svg
// module id = 983
// module chunks = 0